import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'interpolate',
    standalone: true,
})
export class InterpolatePipe implements PipeTransform {
    transform(text: string, params: { [key: string]: string | number | undefined }): string {
        const str = text ?? '';

        if (!text || !params) {
            return str;
        }

        const pattern = new RegExp(/\{\{\s*([^{}]+?)\s*\}\}/, 'g'); // {{ value }}
        return str.replace(pattern, (_, key) => {
            const value = params[key];

            if (!value || value === undefined) {
                console.warn('no value found for ${key}');
                return '';
            }

            return String(value);
        });
    }
}
